import { useState } from "react";

export const UNEXPECTED_ERROR_DETAIL = "Unexpected error";

export function extractLogMessage(err) {
  const logMessage = err?.data?.logMessage;
  if (typeof logMessage === "string" && logMessage.trim()) {
    return logMessage.trim();
  }
  return "";
}

export function apiCaughtError(err, formatter) {
  return {
    message: formatter(err),
    logMessage: extractLogMessage(err),
  };
}

export function isUnexpectedErrorMessage(message) {
  return String(message ?? "").trim() === UNEXPECTED_ERROR_DETAIL;
}

function errorDisplay(error) {
  if (!error) {
    return null;
  }
  if (typeof error === "string") {
    return { message: error, logMessage: "" };
  }
  if (typeof error.message === "string") {
    return { message: error.message, logMessage: error.logMessage || extractLogMessage(error) };
  }
  const detail = error?.data?.detail;
  return {
    message: typeof detail === "string" && detail.trim() ? detail.trim() : UNEXPECTED_ERROR_DETAIL,
    logMessage: extractLogMessage(error),
  };
}

export function ApiErrorText({ error, className }) {
  const [logOpen, setLogOpen] = useState(false);
  const display = errorDisplay(error);
  if (!display?.message) {
    return null;
  }

  const unexpected = isUnexpectedErrorMessage(display.message);
  const logText =
    display.logMessage ||
    "The server did not return a log message. Check the backend log for Unhandled error.";

  return (
    <>
      {unexpected ? (
        <button
          type="button"
          onClick={() => setLogOpen(true)}
          className={`${className} underline underline-offset-2 hover:no-underline text-left`}
          aria-haspopup="dialog"
        >
          Unexpected error
        </button>
      ) : (
        <p className={className}>{display.message}</p>
      )}
      {logOpen ? (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
          <button
            type="button"
            className="absolute inset-0 bg-black/50"
            aria-label="Close error details"
            onClick={() => setLogOpen(false)}
          />
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="unexpected-error-title"
            className="relative z-[71] w-full max-w-xl rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-6 text-gray-900 dark:text-gray-100"
          >
            <h2 id="unexpected-error-title" className="text-lg font-semibold">
              Unexpected error
            </h2>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
              Message from the server log
            </p>
            <pre className="mt-4 max-h-80 overflow-auto whitespace-pre-wrap break-words rounded border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 px-3 py-2 text-xs text-gray-900 dark:text-gray-100">
              {logText}
            </pre>
            <div className="mt-4 flex justify-end">
              <button type="button" className="app-btn-gloss" onClick={() => setLogOpen(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
